export default {
    customer:{
        logintitle:'賬號登錄',
        email:'郵箱',
        password:'密碼',
        loginbtn:'登錄',
        loginSuccess:'登錄成功',
        otherloginMode:'其他登錄方式',
        RechargeCore:'儲值中心',
        RechargeCores:'儲值中心 - U.LU Games',
        AccountsDele:'賬號被刪除',
        AccountsSeal:'賬號被封禁',
        PasswordError:'密碼錯誤',
        AccountsNotence:'賬號不存在',
        EmailFormatError:'郵箱格式不正確',
        PlacePassword:'請輸入密碼',
        PlaceEmail:'請輸入郵箱',
        parameterIncomplete:'參數不全',
        Rechargeption:'(儲值說明)',
        Rechargeption2:'儲值說明',
        obtainGameFail:'遊戲獲取失敗，請重新打開頁面',
        placePayMode:'請選擇付費方式',
    },
    RechargePage:{
        logout:'登出',
        Rechargeccount:'儲值賬號',
        game:'遊戲',
        TheServer:"伺服器",
        RoleNickname:"角色暱稱",
        placeChTheSer:"請選擇伺服器",
        PlaceChNickN:"請選擇暱稱",
        PayMode:"付費方式",
        ChoosCommodity:"選擇商品",
        OrderHathair:"訂單未完成",
        HelpConCusSer:"如需幫助，請聯繫客服cs@ulugame.com",
        GlobalException:"全局異常",
        good:"好的",
        OrderCompleted:"訂單已完成",
        SuccessBuy:"您已購買成功",
        Ordercancelled:'訂單已取消',

        Databaseerror:"資料庫異常",
        operror:"資料庫操作異常",
        Invaildlogin:'無效的登錄，請重新嘗試',
        Emailwasbinded:'郵箱賬號已被綁定',
        Codeerror:'驗證碼錯誤',
        bindedalready:'社媒賬號已被綁定',
        ULUaccount:"當前賬號已綁定ULU賬號",
        Codeinvalid:'驗證碼已過期',
        haveRegist:"賬號已註冊，請前往登錄",
        Requestfrequently:"請求頻繁，請稍微嘗試",
        notRegister:"未註冊",
        oneBind:"解除綁定所有社媒賬號前，請先綁定郵箱",
        idError:"賬號錯誤，請輸入正確的解綁賬號",
        Noorvicnleund:'未查到伺服器與角色',
        gamesempty:'游戲爲空',
        determin:'確定',
        Rechargeonfirmation:'充值確認',
        Confirmwingarormation:'請確認以下充值資訊。',
        BuyGoods:'購買商品',
        cancel:'取消',

        RoleNickID:'角色ID',
        PlaceNickID:'請輸入角色ID',
        check:'校驗',
        PlaceCheckID:'請先校驗角色ID',
        CheckSuccess:'校驗成功，角色名為：',
        VerificationFailed:'校驗失敗，角色不存在',
        SystemError:'系統錯誤',
        InterfaceException:'接口異常',
        FrequentVisits:'訪問過於頻繁',
        NetworkAnomaly:'網絡異常',
        PleLoginFirst:'請先登錄游戲賬號',
        RecharRoleInformation:'儲值角色資訊',
        TotalAmount:'縂金額',
        ImmediatePayment:'立即支付',
        PleaseVerifyServer:'請校驗伺服器',
        PayRole:'儲值角色',
        PlsselectRole:'請選擇角色'
    },
}
